import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { ViewProductDetailDataModal } from './Modal_ViewProductDetails';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { Modal_Checkout_Hotel_Restaurant } from './Modal_Checkout_Hotel_Restaurant';

import { Preferences } from '@capacitor/preferences';
import { format, compareAsc } from 'date-fns';


function addStorage_cart(event) {

    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}


 export function Tab_Dining_And_Bar (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);

    let [addProductModal, setAddProductModal] = useState(false);
    let [modifyProductModal, setModifyProductModal] = useState(false);
    let [viewInventoryProductMainDetailsData_online, setViewInventoryProductMainDetailsData_online] = useState([]);
    let [viewInventoryProductMainDetailsData_onsite, setViewInventoryProductMainDetailsData_onsite] = useState([]);

    let [viewProductDetailsData, setViewProductDetailsData] = useState([]);
    let [showProductDetails, setShowProductDetails] = useState(false);

    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);

    let [deleteInventoryProductModal, setDeleteInventoryProductModal] = useState(false);
    let [adminPasswordCreateInventoryProductModal, setAdminPasswordCreateInventoryProductModal] = useState(false);
    let [adminPasswordDeleteProductModal, setAdminPasswordDeleteProductModal] = useState(false);

    let [activateProductButton, setActivateProductButton] = useState('inline-block');
    let [deactivateProductButton, setDeactivateProductButton] = useState('inline-block');

    let [productQuantity, setProductQuantity] = useState(1);

    let [showProductPics, setShowProductPics] = useState(false);
    let [itemID, setItemID] = useState(null);
    let [productID, setProductID] = useState(null);
    let [productSalePrice, setProductSalePrice] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productPic1, setProductPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic2, setProductPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic3, setProductPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [productPic4, setProductPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");

    let [openCheckoutModal, setOpenCheckoutModal] = useState(false);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [cartSubTotal, setCartSubTotal] = useState(null);
    let [cartCheckoutTotal, setCartCheckoutTotal] = useState(null);

    let [discountOfList, setDiscountOfList] = useState(null);
    let [salePrice, setSalePrice] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);

    let [searchResults, setSearchResults] = useState([]);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);

    let [viewIonPopover, setvViewIonPopover] = useState(false);
    let [viewIonPopover_cart, setvViewIonPopover_cart] = useState(false);
    let [viewIonPopover_setQty, setvViewIonPopover_setQty] = useState(false);
    let [viewInventoryOccupiedRooms, setViewInventoryOccupiedRooms] = useState([]);

    const [cartList, setCartList] = useState(authenticatedMerchent_context.cartList);

    let [viewFood, setViewFood] = useState(false);
    let [viewFoodBorder, setViewFoodBorder] = useState('none');
    let [viewDrink, setViewDrink] = useState(true);
    let [viewDrinkBorder, setViewDrinkBorder] = useState('2px solid black');

    let [addItemEvent, setAddItemEvent] = useState(null);


    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let salePriceRef = useRef('');
    let discountOfListRef = useRef('');
    let itemIDRef = useRef('');
    let productIDRef = useRef('');
    let productNameRef = useRef('');
    let productItemNameRef = useRef('');






    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        if(searchCategory === 'stock_product')
        {

            Tracker = '74302_stock_product';
        }
        else if(searchCategory === 'delete_stock_product')
        {

            Tracker = '74304_delete_stock_product';

        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '72302_search_inventory_items',
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_productId: cols[0],
                                        db_productName: cols[1],
                                        db_productDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });

                            }

                    })
        }

    function getMenu_food() {
            
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74401_restaurant_retrieveMenu_food',
                user: acctID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewInventoryProductMainDetailsData_online((prevViewInventoryProductMainDetailsData) => {
                    return prevViewInventoryProductMainDetailsData.concat({
                        productID: cols[0],
                        item_id_list: cols[1],
                        productType: cols[2],
                        productName: cols[3],
                        productPartNum: cols[4],
                        productPhoneNumber: cols[5],
                        productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                        productSalePrice: parseFloat(cols[7]).toFixed(2),
                        productPic1: cols[8],
                        productPic2: cols[9],
                        productPic3: cols[10],
                        productPic4: cols[11],
                        productDateCreated: cols[12],
                        productAddedBy: cols[13],
                        productIsActivated: cols[14],
                    })
                });

            } 
        })
        
}

function getMenu_drinks() {
            
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74401_restaurant_retrieveMenu_drinks',
            user: acctID,
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setViewInventoryProductMainDetailsData_onsite((prevViewInventoryProductMainDetailsData) => {
                return prevViewInventoryProductMainDetailsData.concat({
                    productID: cols[0],
                    item_id_list: cols[1],
                    productType: cols[2],
                    productName: cols[3],
                    productPartNum: cols[4],
                    productPhoneNumber: cols[5],
                    productCostPerUnit: parseFloat(cols[6]).toFixed(2),
                    productSalePrice: parseFloat(cols[7]).toFixed(2),
                    productPic1: cols[8],
                    productPic2: cols[9],
                    productPic3: cols[10],
                    productPic4: cols[11],
                    productDateCreated: cols[12],
                    productAddedBy: cols[13],
                    productIsActivated: cols[14],
                    itemQtyInStock: cols[15],

                })
            });

        } 
    })
    
}


let timeout;

function productDetailsHandler(event)
{
    //alert("in product details handler");
    //alert(event[1]);


    setProductID(event[1]);
    setProductSalePrice(event[2]);
    setShowProductDetails(event[0]);
}

function addToInvoiceHandler(event)
{
    
    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: '74102',
            user: acctID,
            xStartDateRange: authenticatedMerchent_context.startDate,
            xEndDateRange: authenticatedMerchent_context.endDate,
            sessionID: sessionID,

        }),
    }

    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        let rows = res.toString().split('~~~');

        for (let rownum = 0; rownum < rows.length - 1; ++rownum)
        {
            let cols = rows[rownum].split('|');

            setViewInventoryOccupiedRooms((prevOccupiedRooms) => {
                return prevOccupiedRooms.concat({

                    roomGuestFirstName: cols[0],
                    roomGuestLastName: cols[1],
                    roomGuestPhoneNumber: cols[2],
                    roomGuestPrice: parseFloat(cols[3]).toFixed(2),
                    //roomGuestCheckOutDateBooked: new Date(cols[4]).toISOString().substr(0, 10),
                    roomGuestCheckOutDateBooked: format(new Date(cols[4]), 'E') + ", " + format(new Date(cols[4]), 'MM/dd'),
                    roomGuestCheckInDateActual: format(new Date(cols[5]), 'E') + ", " + format(new Date(cols[5]), 'MM/dd'),
                    merchantInvoiceID: cols[6],
                    roomGuestInvoiceAttachment: cols[7],
                    room_id_multiple: cols[8],
                    roomID: cols[9],
                    roomType: cols[10],
                    roomDescription: cols[11],
                    roomPartNum: cols[12],
                    roomPhoneNumber: cols[13],
                    address: cols[14],
                    city: cols[15],
                    country: cols[16],
                    roomSalePrice: parseFloat(cols[17]).toFixed(2),
                    attachment: cols[18],

                })
            });
        } 
        
       // setProductID(event[2]);
        setvViewIonPopover(true)
    })
}

function popOverSelection(event)
{

    // alert(event);
    // alert(event[0]);
    // alert(event[1]);
    // alert(event[2]);

   // alert(JSON.stringify(cartList));

    let requestOptions = {};

    if(event[2] == "single")
    {
        requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74102_addMenuItemToInvoice',
                user: acctID,
                xCartList: JSON.stringify(cartList),
                xMerchantInvoiceID: event[0],
                xCheckInRoomID: event[1],
                sessionID: sessionID,
    
            }),
        }
    }
    
    if(event[2] == "multiple")
    {
        requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74102_addMenuItemToInvoice_multiple',
                user: acctID,
                xCartList: JSON.stringify(cartList),
                xMerchantInvoiceID: event[0],
                xCheckInRoomID_multiple: event[1],
                sessionID: sessionID,
    
            }),
        }
    }
    
    alert("before fetch");

    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);
        
        setvViewIonPopover(false)
    })

}

function setQuanittyFunction(event)
{
    setAddItemEvent(event);
    setvViewIonPopover_setQty(true);
}

function addToCartHandler(event) 
{

    //alert(event);

    let cartItems = {
        id: event[0][1],
        name: event[0][2],
        price: event[0][3],
        quantity: event[1],
        };

    setCartList((prevCartList) => {
        const updatedCartList = [...prevCartList, cartItems]; // Keep old items + new one

        // Store the updated list in local storage
        addStorage_cart(updatedCartList);

        return updatedCartList; // Update state
    });

    authenticatedMerchent_context.changeCartList((prevCartList) => {
        return [...prevCartList, cartItems];
    });


    alert("ITEM ADDED TO CART");
    setvViewIonPopover_setQty(false);
    setProductQuantity(1);

}


async function deleteCartItem(index){


    const updatedCartArrayList = cartList.filter((_, i) => i !== index);

    setCartList(updatedCartArrayList);

    await addStorage_cart(updatedCartArrayList);


    authenticatedMerchent_context.changeCartList(updatedCartArrayList);


    let cartSubtotal = 0;

    for (let rownum = 0; rownum < updatedCartArrayList.length; ++rownum)
    {

        let cartItems = updatedCartArrayList[rownum];

        cartSubtotal += cartItems.price * cartItems.quantity;

    }
    

    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);

  };

function handleFood()
{
    setViewFood(true);
    setViewFoodBorder('2px solid black');

    setViewDrink(false);
    setViewDrinkBorder('none');

}
function handleDrink()
{
    setViewFood(false);
    setViewFoodBorder('none');

    setViewDrink(true);
    setViewDrinkBorder('2px solid black');

}

useEffect(() =>  {
        
    getMenu_food(); 

    getMenu_drinks();   

}, [])


        return (

            <React.Fragment>

                    {viewIonPopover_cart && (

                    <div
                    //onClick={() => setvViewIonPopover_cart(false)} // Close on backdrop click
                    style={{
                    position: 'absolute',
                    width: '75%',
                    height: '60%',
                    backgroundColor: 'white',
                    transform: 'translate(10%, 0%)',
                    padding: '16px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                    borderRadius: '8px',       /* Rounded corners */
                    border: '2px rgb(0, 0, 0) solid',
                    }}
                    >

                    <IonGrid className='popOver'>
                        <IonRow >
                                <IonCol size='3'>Name</IonCol>
                                <IonCol size='3'>Price</IonCol>
                                <IonCol size='3'>Quantiy</IonCol>
                                <IonCol size='3'>Action</IonCol>
                            </IonRow>

                        {cartList.map((detailData, index) =>   {
                        return (
                            <IonRow key={detailData.id || index}>
                                <IonCol size='3'>{detailData.name || "N/A"}</IonCol>
                                <IonCol size='3'>{detailData.price || "N/A"}</IonCol>
                                <IonCol size='3'>{detailData.quantity || "N/A"}</IonCol>
                                <IonCol size='3'><IonButton className='small_button' onClick={() => deleteCartItem(index)}>Remove</IonButton></IonCol>
                            </IonRow>
                                )
                            }
                        )}
                    </IonGrid>
                    <IonButton onClick={() => setvViewIonPopover_cart(false)}>close</IonButton>
                    </div>
                    )}   

                    {viewIonPopover == true && (
                        <div
                        style={{
                        position: 'absolute',
                        width: '75%',
                        height: '60%',
                        backgroundColor: 'white',
                        transform: 'translate(10%, 0%)',
                        padding: '16px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        borderRadius: '8px',       /* Rounded corners */
                        border: '2px rgb(0, 0, 0) solid',
                        }}
                        >

                        <IonGrid>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonText>SELECT ROOM</IonText>
                                        </IonCol>
                                        <IonCol size='6'>
                                        <select name="paymenttype" id='paymenttype' onChange={(e) => popOverSelection(e.target.value.toString().split(',')) }>
                                            <option value='null' selected='selected'>Make Selection</option>
                                            {viewInventoryOccupiedRooms.map((detailData) =>   {
                                            return (
                                                <option value={[detailData.merchantInvoiceID, detailData.room_id_multiple != "NO" ? detailData.room_id_multiple : detailData.roomID, detailData.room_id_multiple != "NO" ? "multiple" : "single"]} >{detailData.room_id_multiple != "NO" ? detailData.room_id_multiple : detailData.roomID}  - Invoice {detailData.merchantInvoiceID} </option>
                                            )
                                            }
                                            )}
                                        </select>
                                        </IonCol>
                                    </IonRow>
                        </IonGrid>
                        <IonButton onClick={() => setvViewIonPopover(false)}>close</IonButton>
                        </div>
                        )}   

                        
                        {viewIonPopover_setQty == true && (
                        <div
                        style={{
                        position: 'absolute',
                        width: '75%',
                        height: '60%',
                        backgroundColor: 'white',
                        transform: 'translate(10%, 0%)',
                        padding: '16px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        borderRadius: '8px',       /* Rounded corners */
                        border: '2px rgb(0, 0, 0) solid',
                        }}
                        >

                        <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonText>SET QUANTITY</IonText>
                                        </IonCol>                                                                        
                                    </IonRow>
                                    <IonRow>
                                    <IonCol size='2'>
                                        <IonButton
                                            onClick={() => setProductQuantity(prev => Math.max(1, Number(prev) - 1))}
                                        >−</IonButton>
                                        </IonCol>
                                        <IonCol size='4'>
                                            <IonInput type='number' value={productQuantity} onChange={(e) => setProductQuantity(e.target.value)}></IonInput>
                                        </IonCol>
                                        <IonCol size='2'>
                                            <IonButton onClick={() => setProductQuantity(Number(productQuantity) + 1)}>+</IonButton>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton onClick={() => setvViewIonPopover_setQty(false)}>close</IonButton>
                                        </IonCol>
                                        <IonCol>
                                            <IonButton onClick={() => addToCartHandler([addItemEvent, productQuantity])}>Confirm</IonButton>
                                        </IonCol>
                                    </IonRow>
                        </IonGrid>
                        </div>
                        )}   

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            {/*<IonCol size='4'>
                                <IonButton onClick={() => addToInvoiceHandler()}> Invoice </IonButton>
                            </IonCol>*/}
                            <IonCol size='6'>
                                <IonButton onClick={() => setvViewIonPopover_cart(true)}> Cart</IonButton>
                            </IonCol>
                            <IonCol size='6'>
                                <IonButton onClick={() => setOpenCheckoutModal(true)}> Checkout </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>
                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='6' style={{border: viewDrinkBorder}} onClick={() => handleDrink()}>
                                <IonText> DRINK </IonText>
                            </IonCol>
                            <IonCol size='6' style={{border: viewFoodBorder}} onClick={() => handleFood()}>
                                <IonText> FOOD </IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{border: '2px solid black' }}>
                                {/*<IonCol size="3">ID</IonCol>*/}
                                <IonCol size="4">Name</IonCol>
                                <IonCol size="3">Price</IonCol>
                                {/*<IonCol >Margin</IonCol>*/}
                                <IonCol size="5">Action</IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>
                <IonContent className='appContent_restaurant'>           
                            <div className='appContent_restaurant'>

                                <IonGrid >

                                {viewDrink == true &&
                                    viewInventoryProductMainDetailsData_onsite.map((detailData) =>   {
                                    return (
                                        <IonRow>
                                            {/*<IonCol size="1">{detailData.productID}</IonCol>*/}
                                            <IonCol size="5">{detailData.productName}</IonCol>
                                            <IonCol size="2">{detailData.productSalePrice}</IonCol>
                                            {/*<IonCol >{detailData.margin}</IonCol>*/}
                                            <IonCol size="4">
                                            <IonButton className= 'small-button-tabs' onClick={() => setQuanittyFunction([true, detailData.productID, detailData.productName, detailData.productSalePrice])}> Add To Cart </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            
                                {viewFood == true &&
                                    viewInventoryProductMainDetailsData_online.map((detailData) =>   {
                                        return (
                                            <IonRow>
                                                {/*IonCol size="3">{detailData.productID}</IonCol>*/}
                                                <IonCol size="4">{detailData.productName}</IonCol>
                                                <IonCol size="3">{detailData.productSalePrice}</IonCol>
                                                {/*<IonCol >{detailData.margin}</IonCol>*/}
                                                <IonCol size="5">
                                                    <IonButton className= 'small-button-tabs' onClick={() => setQuanittyFunction([true, detailData.productID, detailData.productName, detailData.productSalePrice])}> Add To Cart </IonButton>
                                                </IonCol>
                                            </IonRow>
                                        )
                                }
                                )}
                                    

                            </IonGrid>
                            

                {productPicsModal == true &&  <ShowProductPicsModal openModal={ productPicsModal } closeModal={() => setProductPicsModal(false)} data={{
                        productPic1: productPic1, 
                        productPic2: productPic2, 
                        productPic3: productPic3, 
                        productPic4: productPic4, 
                        productID: productID, 
                        productSalePrice: productSalePrice
                        }}>
                    </ShowProductPicsModal>}

                

                    {showProductDetails == true &&  <ViewProductDetailDataModal openModal={ showProductDetails } closeModal={() => setShowProductDetails(false)} data={{
                        productID: productID, 
                        productSalePrice: productSalePrice
                        }}>
                    </ViewProductDetailDataModal>}


                    {openCheckoutModal == true &&   <Modal_Checkout_Hotel_Restaurant openModal={ openCheckoutModal } closeModal={() => setOpenCheckoutModal(false)}  data={{
                        companyId: acctID,
                        companyPhoneNumber: authenticatedMerchent_context.companyPhoneNumber,
                        cartList: cartList,
                        }}></Modal_Checkout_Hotel_Restaurant> }

            </div>
                
            </IonContent>
            </React.Fragment>

        )
    }   



export default Tab_Dining_And_Bar;